import { render, staticRenderFns } from "./changBill.vue?vue&type=template&id=2cb4ebb7&scoped=true&"
import script from "./changBill.vue?vue&type=script&lang=js&"
export * from "./changBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb4ebb7",
  null
  
)

export default component.exports